import React from 'react'
import ControlsBar from './'
import SlideshowControls from '../SlideshowControls'
import MovieControls from '../MovieControls'
import {EventBusContext, PowtoonEventType} from 'powtoon-commons/events'

const Controls = ({
  toggleFullScreen, setVolume, corePlayerConnection, fullscreenEnabled,
  isFullscreen, showControlsBar, currentSlideIndex, currentSlideTime,
  currentTime, isPlaying, isEnd, isUpdating, slideshowMode, hideControls,
  setControlsBarRef, setSlideshowControlsRef, adjustedCurrentSlideTotalTime,
  setMovieControlsRef, hideFullScreenButton, play, pause, showLogo, captionLocales,
  setActiveCaptionLocale, numberOfSlides, totalDuration, isDisableMovieControls, hideVolumeControl, initialCaptionLocale
}) => {

  const disableControlsBar = hideControls || !corePlayerConnection || isUpdating
  const hideControlsBar = !showControlsBar && !isEnd

  const {eventBus} = React.useContext(EventBusContext)
  React.useEffect(() => {
    if (toggleFullScreen){
      eventBus.on(PowtoonEventType.PlayerToggleFullScreen, toggleFullScreen)
    }
    return () => {
      if (toggleFullScreen){
        eventBus.off(PowtoonEventType.PlayerToggleFullScreen, toggleFullScreen)
      }
    }
  }, [])

  if (disableControlsBar) {
    return null
  }

  return (
    <ControlsBar
      {...{
        key: 'ControlBar',
        ref: setControlsBarRef,
        hideControlsBar,
        initialVolume: corePlayerConnection.volume,
        setVolume,
        fullscreenEnabled,
        toggleFullScreen,
        hideFullScreenButton,
        isFixed: isFullscreen,
        showLogo,
        hideVolumeControl,
        captionLocales,
        setActiveCaptionLocale,
        initialCaptionLocale
      }}
    >
      {slideshowMode
        ? (
          <SlideshowControls
            key="SlideshowControls"
            ref={setSlideshowControlsRef}
            currentSlide={currentSlideIndex}
            currentTotalTime={adjustedCurrentSlideTotalTime}
            currentTime={currentSlideTime}
            isPlaying={isPlaying}
            isStart={currentTime === 0}
            isEnd={isEnd}
            corePlayerConnection={corePlayerConnection}
            numberOfSlides={numberOfSlides}
          />
        )
        : (
          <MovieControls
            key="MovieControls"
            ref={setMovieControlsRef}
            currentTime={currentTime}
            totalDuration={totalDuration}
            isPlaying={isPlaying}
            isEnd={isEnd}
            corePlayerConnection={corePlayerConnection}
            play={play}
            pause={pause}
            disabled={isDisableMovieControls}
          />
        )}
    </ControlsBar>
  )
}

export default Controls
